module.exports = __webpack_public_path__ + "color_palette_josif_pancic.png?57ed8be7af85ebbcacbdf5585705099f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/color_palette_josif_pancic.png
// module id = 71
// module chunks = 0